import { effect, inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BrandingStore, DEFAULT_LEGAL_NAME } from 'src/core/stores/branding.store';

// Una marca que no se pudo obtener no pone un nombre en la pestaña: el respaldo
// es solo para el tenant que respondió sin nombre legal (LF.1).
@Injectable({ providedIn: 'root' })
export class BrandingTitleService {
  private readonly branding = inject(BrandingStore);
  private readonly title = inject(Title);

  constructor() {
    effect(() => {
      const legalName = this.branding.error() ? '' : this.branding.config()?.legalName;
      this.title.setTitle(legalName || DEFAULT_LEGAL_NAME);
    });
  }
}
